export const AUTHORIZATION = "Authorization";
export const NEXT_LOCALE = "NEXT_LOCALE";
export const PSP_COOKIE = "psp";
export const FEEDBACK_MODAL_DISMISSED = "feedback_modal_dismissed";
